// extracted by mini-css-extract-plugin
export default {"buttons":"AddedToBasketOverlay_buttons__2ko0X","errorsUl":"AddedToBasketOverlay_errorsUl__VFlZ8","header":"AddedToBasketOverlay_header__iLjAx"};